export default __webpack_public_path__ + "files/FP2_FINANCIAL_I_NSTRUMENTS_GENERAL_CONCEPTS.pdf";